
































import { Popover } from 'element-ui';
import copyObj from '@/util/copyObj';
import { UsersAppParams } from '@/store/interfaces/usersApp';
import { ContactKindParams } from '@/store/interfaces/contact';
import { CommerceParams } from '@/store/interfaces/commerce';
import { BranchParams } from '@/store/interfaces/branchs';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'BadgesTarget',
  components: {
    'el-popover': Popover,
  },
  props: {
    data: {
      type: Array as PropType<
        Array<
          UsersAppParams | ContactKindParams | CommerceParams | BranchParams
        >
      >,
      required: true,
    },
    keyToShow: {
      type: String,
      default: 'name',
    },
    dataToShow: {
      type: Number,
      default: 3,
    },
  },
  methods: {
    lengthCalculate(
      array: Array<
        UsersAppParams | ContactKindParams | CommerceParams | BranchParams
      >
    ): number {
      return array.length;
    },
  },
  computed: {
    dataPopoper(): Array<
      UsersAppParams | ContactKindParams | CommerceParams | BranchParams
      > {
      const copyData = copyObj(this.data);
      copyData.splice(0, this.dataToShow);
      return copyData;
    },
  },
});
